import React from 'react'
import { Box } from '@chakra-ui/react'

import { MarkdownRenderer } from '../../markdown-renderer'
import { CopyFormItem } from '../form-types'

interface CopySectionProps {
  section: CopyFormItem;
}

export const CopySectionComponent: React.FC<CopySectionProps> = ({ section, ...rest }) => {
  return (
    <Box mb="small" sx={{
      breakInside: 'avoid',
      position: 'relative',
      breakBefore: 'auto',
      breakAfter: 'auto',
    }} {...rest}>
      <MarkdownRenderer>
        {section.content.markdown}
      </MarkdownRenderer>
    </Box>
  )
}

export const FormCopySection = React.memo(CopySectionComponent, (prevProps, nextProps) => prevProps.section.id === nextProps.section.id)